function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    // iOS 26 Safari fix: Safari's Liquid Glass viewport no longer paints
    // fixed/sticky content behind the dynamic toolbar chrome. We use a
    // three-part workaround (Apple.com pattern):
    // (a) Set body background to the menu color so Safari's toolbar
    //     adopts the correct color via Liquid Glass.
    // (b) Inject a small fixed shell element (< 50vh tall) with an
    //     inner 100vh child that paints behind the toolbar region.
    // (c) Hide main page content (via CSS .menu-open class) so it
    //     doesn't bleed through Safari's translucent chrome.
    //
    // Only applied on mobile (< 750px) where the drawer is full-width.
    // At 750px+ the drawer is 40rem and the existing overlay provides
    // sufficient dimming — a solid body color would blank the visible page.
    this._ios26Cleaning = false; // reset for new open cycle
    this._applyIOS26(window.innerWidth < 750);

    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    this._cleanupIOS26();
  }

  // Apply or remove the iOS 26 solid-body-bg + viewport-shell fix.
  // Only needed on mobile (< 750px) where the drawer is full-width.
  _applyIOS26(apply) {
    const drawer = this.querySelector('.menu-drawer');
    if (!drawer) return;

    if (apply) {
      if (this._ios26Active) return; // already applied
      this._ios26Active = true;
      const drawerBg = getComputedStyle(drawer).backgroundColor;
      this._previousBodyBg = document.body.style.backgroundColor;
      document.body.classList.add('menu-drawer-bg-transition');
      document.body.style.backgroundColor = drawerBg;

      if (!this._viewportShell) {
        this._viewportShell = document.createElement('div');
        this._viewportShell.className = 'menu-drawer-viewport-shell';
        this._viewportShellInner = document.createElement('div');
        this._viewportShellInner.className = 'menu-drawer-viewport-shell__inner';
        this._viewportShell.appendChild(this._viewportShellInner);
      }
      this._viewportShellInner.style.backgroundColor = drawerBg;
      document.body.appendChild(this._viewportShell);
    } else {
      // Remove solid background if we're above mobile width
      if (!this._ios26Active) return;
      this._ios26Active = false;
      if (this._previousBodyBg !== undefined) {
        document.body.style.backgroundColor = this._previousBodyBg;
        delete this._previousBodyBg;
      }
      document.body.classList.remove('menu-drawer-bg-transition');
      if (this._viewportShell && this._viewportShell.parentNode) {
        this._viewportShell.parentNode.removeChild(this._viewportShell);
      }
    }
  }

  // Separated so it can't be blocked by the elementToFocus guard.
  // Uses a flag to prevent transitionend + setTimeout double-fire.
  _cleanupIOS26() {
    if (this._ios26Cleaning) return;
    this._ios26Cleaning = true;
    this._ios26Active = false;

    if (this._previousBodyBg !== undefined) {
      document.body.style.backgroundColor = this._previousBodyBg;
      delete this._previousBodyBg;

      const cleanup = () => {
        if (!this._ios26Cleaning) return;
        this._ios26Cleaning = false;
        document.body.classList.remove('menu-drawer-bg-transition');
        if (this._viewportShell && this._viewportShell.parentNode) {
          this._viewportShell.parentNode.removeChild(this._viewportShell);
        }
      };
      document.body.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, 500);
    } else {
      this._ios26Cleaning = false;
      document.body.classList.remove('menu-drawer-bg-transition');
      if (this._viewportShell && this._viewportShell.parentNode) {
        this._viewportShell.parentNode.removeChild(this._viewportShell);
      }
    }
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (isOpen) {
      // Toggle iOS 26 solid-body fix based on whether we're at mobile width.
      // At 750px+ the drawer is 40rem wide and the semi-transparent overlay
      // handles dimming — no need to blank the whole page.
      this._applyIOS26(window.innerWidth < 750);

      // If the viewport has grown past the breakpoint where the drawer is
      // hidden by CSS (e.g. portrait → landscape rotation on tablet), close
      // the menu programmatically.
      const breakpoint = this.dataset.breakpoint === 'desktop' ? Infinity : 990;
      if (window.innerWidth >= breakpoint) {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.classList.remove('menu-opening');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', false);
        this.header.classList.remove('menu-open');
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus();
        this._cleanupIOS26();
      }
    }
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.dotLinks = this.querySelectorAll('.slider-counter__link--dots');
    if (this.dotLinks.length) {
      this.dotLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.slider.scrollTo({ left: index * this.sliderItemOffset });
        });
      });
    }

    this.slider.addEventListener('scroll', this.update.bind(this));
    if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.dotLinks && this.dotLinks.length) {
      this.dotLinks.forEach((link, i) => {
        link.classList.toggle('slider-counter__link--active', i === this.currentPage - 1);
        if (i === this.currentPage - 1) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variantDataCache = null; // Pre-parsed variant data cache
    this.pendingUpdate = null; // For batching updates
    
    // Use immediate response with RAF batching instead of debounce
    this.addEventListener('change', (e) => {
      this.onVariantChange(e);
    });
  }

  onVariantChange(e) {
    // Cancel any pending batched update
    if (this.pendingUpdate) {
      cancelAnimationFrame(this.pendingUpdate);
    }

    // Batch all DOM updates in a single animation frame
    this.pendingUpdate = requestAnimationFrame(() => {
      this.updateOptions();
      this.updateMasterId();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // All updates happen client-side, no server fetch needed
        this.updateMediaInstant();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfoInstant();
        this.updateShareUrl();
        this.updatePickupAvailability();
      }
      
      this.pendingUpdate = null;
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    // Try to get variant ID directly from selected input (for duplicate variant names)
    const selectedInput = this.querySelector('input[type="radio"]:checked, select option:checked');
    
    if (selectedInput && selectedInput.dataset.variantId) {
      // Use variant ID for direct lookup (handles duplicate names)
      this.currentVariant = this.getVariantData().find(
        variant => variant.id == selectedInput.dataset.variantId
      );
    } else {
      // Fallback to option-matching logic for backward compatibility
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  }

  updateMediaInstant() {
    if (!this.currentVariant) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;

    let mediaIdToUse = null;

    // If variant has its own featured image, use it
    if (this.currentVariant.featured_media && this.currentVariant.featured_media.id) {
      mediaIdToUse = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    } 
    // Otherwise, fallback to product's first/default image that is NOT a variant-specific image
    else {
      // Get all variant media IDs to exclude them
      const allVariants = this.getVariantData();
      const variantMediaIds = allVariants
        .filter(v => v.featured_media && v.featured_media.id)
        .map(v => v.featured_media.id);
      
      // Find first slide that is NOT a variant-specific image
      const allSlides = mediaGallery.querySelectorAll('[id^="Slide-"][data-media-id]');
      let defaultMediaItem = null;
      
      for (const slide of allSlides) {
        const slideMediaId = slide.getAttribute('data-media-id');
        // Extract numeric ID from format like "template--123--456"
        const numericId = slideMediaId.split('-').pop();
        
        // If this media is NOT assigned to any variant, it's the product default
        if (!variantMediaIds.includes(parseInt(numericId))) {
          defaultMediaItem = slide;
          break;
        }
      }
      
      // If no non-variant image found, use the absolute first image as fallback
      if (!defaultMediaItem && allSlides.length > 0) {
        defaultMediaItem = allSlides[0];
      }
      
      if (defaultMediaItem) {
        mediaIdToUse = defaultMediaItem.getAttribute('data-media-id');
      }
    }

    // If we have a media ID to show, update the gallery
    if (mediaIdToUse) {
      mediaGallery.setActiveMedia(mediaIdToUse, true);

      // Update modal content if it exists
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (modalContent) {
        const newMediaModal = modalContent.querySelector(`[data-media-id="${mediaIdToUse}"]`);
        if (newMediaModal) {
          modalContent.prepend(newMediaModal);
        }
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfoInstant() {
    if (!this.currentVariant) return;

    // Update price instantly using variant data
    this.updatePriceInstant();
    
    // Update stock banner instantly
    this.updateStockBannerInstant();
    
    // Update product information table
    this.updateProductInfoInstant();
    
    // Update button state
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    
    // Refilter the pot selector for the new size
    this.updatePotsSection();
  }

  updatePriceInstant() {
    const priceDestination = document.getElementById(`price-${this.dataset.section}`);
    if (!priceDestination) return;

    const price = this.currentVariant.price;
    const compareAtPrice = this.currentVariant.compare_at_price;
    const isOnSale = compareAtPrice != null && compareAtPrice > price;
    
    // Format prices - handle null values safely
    const formattedPrice = this.formatMoney(price);
    const formattedComparePrice = (compareAtPrice != null) ? this.formatMoney(compareAtPrice) : '';

    // Update price container classes - let CSS handle visibility
    priceDestination.classList.remove('price--on-sale', 'price--sold-out', 'visibility-hidden');
    if (!this.currentVariant.available) {
      priceDestination.classList.add('price--sold-out');
    }
    if (isOnSale) {
      priceDestination.classList.add('price--on-sale');
    }

    // Update regular price (always update both, CSS will show the right one)
    const regularPriceElement = priceDestination.querySelector('.price__regular .price-item--regular');
    if (regularPriceElement) {
      regularPriceElement.textContent = formattedPrice;
    }

    // Update sale price elements (even if not on sale, update them for next time)
    const saleCompareElement = priceDestination.querySelector('.price__sale .price-item--regular');
    if (saleCompareElement) {
      // Update the text content AND control visibility
      saleCompareElement.textContent = formattedComparePrice;
      // Hide the parent span when there's no compare at price
      const saleCompareParent = saleCompareElement.parentElement;
      if (saleCompareParent) {
        saleCompareParent.style.display = isOnSale ? '' : 'none';
      }
    }
    
    const salePriceElement = priceDestination.querySelector('.price__sale .price-item--sale');
    if (salePriceElement) {
      salePriceElement.textContent = formattedPrice;
    }

    // Update sale badge with dynamic discount percentage
    const saleBadge = priceDestination.querySelector('.price__badge-sale');
    if (saleBadge) {
      if (isOnSale) {
        // Calculate discount percentage
        const discountPercent = Math.floor(((compareAtPrice - price) / compareAtPrice) * 100);
        
        // Get "On Sale" text from badge or use default
        const saleText = window.variantStrings?.onSale || 'SALE';
        
        // Update badge text with percentage if discount >= 20%
        if (discountPercent >= 20) {
          saleBadge.textContent = `${saleText} | ${discountPercent}% OFF`;
        } else {
          saleBadge.textContent = saleText;
        }
        saleBadge.style.display = 'inline-block';
      } else {
        saleBadge.style.display = 'none';
      }
    }

    // Show/hide sold out badge
    const soldOutBadge = priceDestination.querySelector('.price__badge-sold-out');
    if (soldOutBadge) {
      soldOutBadge.style.display = this.currentVariant.available ? 'none' : 'inline-block';
    }
  }

  updateStockBannerInstant() {
    const dvhpDestination = document.getElementById(`dvhp-${this.dataset.section}`);
    if (dvhpDestination) {
      const plantHeight = this.currentVariant.plant_height;
      // Always include plant height input if available
      dvhpDestination.innerHTML = plantHeight
        ? `<input id="plant-height" type="hidden" value="${plantHeight}" form="product-form-${this.dataset.section}" name="properties[Plant Height]">`
        : '';
    }

    // Stock banner block (snippets/stock-banner.liquid): all messages are server-rendered, CSS picks one from the data attributes
    const banner = document.getElementById(`stock-banner-${this.dataset.section}`);
    if (banner) {
      banner.dataset.stockLevel = this.currentVariant.stock_level || (this.currentVariant.available ? 'in_stock' : 'out');
      banner.dataset.freeDelivery = String(this.currentVariant.price >= (Number(banner.dataset.freeThreshold) || 4999));
    }
  }

  updateProductInfoInstant() {
    const prodinfoDestination = document.getElementById(`prodinfo-${this.dataset.section}`);
    if (!prodinfoDestination) return;

    const plantHeight = this.currentVariant.plant_height;
    const variantOptions = this.currentVariant.options;
    
    // Update plant height
    const plantHeightCell = prodinfoDestination.querySelector('.plantinfo-td-info-height');
    if (plantHeightCell) {
      plantHeightCell.textContent = plantHeight || 'Plant height coming soon';
    }
    
    // Update pot diameter - use selector that EXCLUDES the height cell
    const potDiameterCell = prodinfoDestination.querySelector('.plantinfo-td-info:not(.plantinfo-td-info-height)');
    if (potDiameterCell && variantOptions) {
      // Format options properly with commas and spaces
      potDiameterCell.textContent = variantOptions.join(', ');
    }
  }

  updatePotsSection() {
    // The <pot-selector> element (assets/pot-selector.js) filters and rebuilds its own tiles.
    const potSelector = document.getElementById(`pot-selector-${this.dataset.section}`);
    if (!potSelector || !this.currentVariant || typeof potSelector.setVariant !== 'function') return;
    potSelector.setVariant(this.currentVariant);
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, theme.moneyFormat || '£{{amount}}');
    }
    // Fallback formatting
    const pounds = (cents / 100).toFixed(2);
    return `£${pounds}`;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    // Cache the parsed JSON to avoid repeated parsing
    if (!this.variantDataCache) {
      const scriptTag = this.querySelector('[type="application/json"]');
      this.variantDataCache = scriptTag ? JSON.parse(scriptTag.textContent) : [];
      
      // Check for enhanced metadata and merge it
      const metadataScript = document.getElementById(`variant-metadata-${this.dataset.section}`);
      if (metadataScript) {
        try {
          const metadata = JSON.parse(metadataScript.textContent);
          if (metadata && metadata.variants) {
            // Merge metadata with variant data
            this.variantDataCache = this.variantDataCache.map(variant => {
              const meta = metadata.variants.find(v => v.id === variant.id);
              return meta ? { ...variant, ...meta } : variant;
            });
          }
        } catch (e) {
          console.error('Error parsing variant metadata:', e);
        }
      }
    }
    return this.variantDataCache;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedInput ? checkedInput.value : '';
    });
  }

  updateMasterId() {
    // For multi-option products, find variant by matching ALL selected option values
    // Don't rely solely on data-variant-id as it may point to wrong variant
    this.currentVariant = this.getVariantData().find((variant) => {
      if (!variant.options || variant.options.length !== this.options.length) {
        return false;
      }
      // Check if ALL options match
      return variant.options.every((optionValue, index) => {
        return this.options[index] === optionValue;
      });
    });
  }
}

customElements.define('variant-radios', VariantRadios);
